<template>
    <div class="page">
      <div class="menu">
        <div class="menu-header flex-row-justify-space-between">
          <p class="font-bold font-size-30 flex-center">多媒体资源</p>
          <p class="font-size-14 font-color-264480 flex-center font-bold cursor" @click="changeAllMenu">{{ menuAllShow?'全部收起':'全部展开' }}</p>
        </div>
        <div class="menu-content">
  
          <!-- 分类 -->
          <div v-if="menu && menu.classificationResource && menu.classificationResource.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">分类</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.attributionType.show?'transform':''" data-typ="attributionType" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.attributionType.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-if="currentCate.parent" class="menu-content-item-list-item">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                      <p class="font-size-14 font-color-white">{{ currentCate.parent.cateName }}</p>
                      <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastCate">x</p>
                    </div>
                  </div>
                  <div v-for="cate in currentCate.logs" :key="cate.id" class="menu-content-item-list-item" @click="selectCate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.attributionType.current == cate.id?'sel':''">
                      <div class="flex">
                        <p v-if="currentCate.parent" class="font-size-14 character">└</p>
                        <p class="font-size-14">{{ cate.cateName }}</p>
                      </div>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 学科 -->
          <div v-if="menu && menu.disciplineRsource && menu.disciplineRsource.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">学科</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.subject.show?'transform':''" data-typ="subject" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.subject.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-if="currentSubject.parent" class="menu-content-item-list-item">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                      <p class="font-size-14">{{ currentSubject.parent.subjectName }}</p>
                      <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastSubject">x</p>
                    </div>
                  </div>
                  <div v-for="cate in currentSubject.logs" :key="cate.id" class="menu-content-item-list-item" @click="selectSubject(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.subject.current == cate.id?'sel':''">
                      <p class="font-size-14">{{ cate.subjectName }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 资源类型 -->
          <div v-if="menu && menu.resourceTypes && menu.resourceTypes.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">资源类型</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.resourceType.show?'transform':''" data-typ="resourceType" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.resourceType.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.resourceTypes" :key="cate.code" class="menu-content-item-list-item" @click="selectFileType(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.resourceType.current == cate.code?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 专题 -->
          <div v-if="menu && menu.resourceTopic && menu.resourceTopic.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">专题</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.tibetanTube.show?'transform':''" data-typ="tibetanTube" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.tibetanTube.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.resourceTopic" :key="cate.name" class="menu-content-item-list-item" @click="selectTopic(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.tibetanTube.current==cate.code?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
  
                <div v-if="menu.resourceTopicTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="topic" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 体裁 -->
          <div v-if="menu && menu.resourceGenre && menu.resourceGenre.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">体裁</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.genre.show?'transform':''" data-typ="genre" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.genre.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-if="currentGenre.parent" class="menu-content-item-list-item">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5 sel">
                      <p class="font-size-14">{{ currentGenre.parent.genreName }}</p>
                      <p class="font-size-14 cate-sel-close flex-center cursor font-color-white" @click="selectLastGenre">x</p>
                    </div>
                  </div>
                  <div v-for="cate in currentGenre.logs" :key="cate.id" class="menu-content-item-list-item" @click="selectGenre(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.genre.current == cate.id?'sel':''">
                      <p class="font-size-14">{{ cate.genreName }}</p>
                      <p v-if="cate.countategory > 0" class="font-size-14 font-color-999">{{ cate.countategory }}</p>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 纪事人物 -->
          <div v-if="menu && menu.documentaryMan && menu.documentaryMan.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">纪事人物</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.personAffected.show?'transform':''" data-typ="personAffected" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.personAffected.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.documentaryMan" :key="cate.name" class="menu-content-item-list-item" @click="selectPerson(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.personAffected.current == cate.name?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="menu.documentaryManTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="person" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 内容语种 -->
          <div v-if="menu && menu.langueMenu && menu.langueMenu.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">内容语种</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.langue.show?'transform':''" data-typ="langue" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.langue.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.langueMenu" :key="cate.dictKey" class="menu-content-item-list-item" @click="selectLanguage(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.langue.current == cate.dictKey?'sel':''">
                      <p class="font-size-14">{{ cate.dictValue }}</p>
                      <p v-if="cate.count>0" class="font-size-14 font-color-999">{{ cate.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 字幕语种 -->
          <div v-if="menu && menu.subtitlesLangueMenu && menu.subtitlesLangueMenu.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">字幕语种</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.subtitlesLangue.show?'transform':''" data-typ="subtitlesLangue" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.subtitlesLangue.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.subtitlesLangueMenu" :key="cate.dictKey" class="menu-content-item-list-item" @click="selectShowLanguage(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.subtitlesLangue.current == cate.dictKey?'sel':''">
                      <p class="font-size-14">{{ cate.dictValue }}</p>
                      <p v-if="cate.count>0" class="font-size-14 font-color-999">{{ cate.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 音频语种 -->
          <div v-if="menu && menu.videoAndAudioLangueMenu && menu.videoAndAudioLangueMenu.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">音频语种</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.videoAndAudioLangue.show?'transform':''" data-typ="videoAndAudioLangue" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.videoAndAudioLangue.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.videoAndAudioLangueMenu" :key="cate.dictKey" class="menu-content-item-list-item" @click="selectAudioLanguage(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.videoAndAudioLangue.current == cate.dictKey?'sel':''">
                      <p class="font-size-14">{{ cate.dictValue }}</p>
                      <p v-if="cate.count>0" class="font-size-14 font-color-999">{{ cate.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 时长 -->
          <div v-if="menu && menu.duration && menu.duration.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">时长</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.resourceTimes.show?'transform':''" data-typ="resourceTimes" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.resourceTimes.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.duration" :key="cate.name" class="menu-content-item-list-item" @click="selectDuration(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.resourceTimes.current == cate.code?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 宽高比 -->
          <div v-if="menu && menu.widthheight && menu.widthheight.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">宽高比</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.widthHeight.show?'transform':''" data-typ="widthHeight" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.widthHeight.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.widthheight" :key="cate.name" class="menu-content-item-list-item" @click="selectWidth(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.widthHeight.current == cate.name?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 创作日期 -->
          <!-- 返回的超过了5个 没有返回条目的总数 -->
          <div v-if="menu && menu.creationDate && menu.creationDate.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">创作日期</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.resourceCreateTimes.show?'transform':''" data-typ="resourceCreateTimes" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.resourceCreateTimes.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.creationDate" :key="cate.name" class="menu-content-item-list-item" @click="selectCreateDate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.resourceCreateTimes.current == cate.name?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="menu.creationDateTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="createDate" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
                <div class="flex-center" style="padding: 15px 20px;">
                  <div class="menu-content-item-list-item-rang flex-row-align-center position-relative bg-white radius-clip-5 flex-1">
                    <el-date-picker
                      v-model="menuDisplay.resourceCreateTimes.rangeDate"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder=""
                      end-placeholder=""
                      size="mini"
                      clear-icon=""
                      prefix-icon=""
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                    />
                  </div>
                  <div class="font-color-white font-size-14 bg-282B80 radius-clip-5 flex-center cursor menu-content-item-list-item-button" @click="selectCreateDate">确认</div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 发布人 -->
          <!-- 没有返回条目的总数 -->
          <div v-if="menu && menu.publisherMenu && menu.publisherMenu.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">发布人</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.commitBy.show?'transform':''" data-typ="commitBy" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.commitBy.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.publisherMenu" :key="cate.userId" class="menu-content-item-list-item" @click="selectPubMan(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.commitBy.current == cate.userId?'sel':''">
                      <p class="font-size-14">{{ cate.userName }}</p>
                      <p v-if="cate.count > 0" class="font-size-14 font-color-999">{{ cate.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="menu.publisherMenuTotal>5" class="flex-row-justify-end menu-content-item-more">
                <div class="flex-row-align-center" data-typ="pubman" @click="showMore">
                  <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                  <img src="@/assets/icon-lib-arrow.png">
                </div>
              </div>
            </div>
          </div>
  
          <!-- 发布日期 -->
          <!-- 没有字段 -->
          <div v-if="menu && menu.releaseDate && menu.releaseDate.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">发布日期</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.publishTimes.show?'transform':''" data-typ="publishTimes" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.publishTimes.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.releaseDate" :key="cate.name" class="menu-content-item-list-item" @click="selectPubDate(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.publishTimes.current == cate.name?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
                <div v-if="menu.releaseDateTotal>5" class="flex-row-justify-end menu-content-item-more">
                  <div class="flex-row-align-center" data-typ="pubdate" @click="showMore">
                    <p class="font-size-14 font-color-264480 font-bold cursor">更多</p>
                    <img src="@/assets/icon-lib-arrow.png">
                  </div>
                </div>
                <div class="flex-center" style="padding: 15px 20px;">
                  <div class="menu-content-item-list-item-rang flex-row-align-center position-relative bg-white radius-clip-5 flex-1">
                    <el-date-picker
                      v-model="menuDisplay.publishTimes.rangeDate"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder=""
                      end-placeholder=""
                      size="mini"
                      clear-icon=""
                      prefix-icon=""
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    />
                  </div>
                  <div class="font-color-white font-size-14 bg-282B80 radius-clip-5 flex-center cursor menu-content-item-list-item-button" @click="selectPubDate">确认</div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 版权 -->
          <!--没有字段 -->
          <div v-if="menu && menu.copyrightResource && menu.copyrightResource.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">版权</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.copyrightOwner.show?'transform':''" data-typ="copyrightOwner" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.copyrightOwner.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.copyrightResource" :key="cate.dictKey" class="menu-content-item-list-item" @click="selectCopyRight(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.copyrightOwner.current == cate.dictValue?'sel':''">
                      <p class="font-size-14">{{ cate.dictKey }}</p>
                      <p v-if="cate.count>0" class="font-size-14 font-color-999">{{ cate.count }}</p>
                    </div>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
          <!-- 权限范围 -->
          <div v-if="menu && menu.scopeOfAuthority && menu.scopeOfAuthority.length" class="menu-content-item radius-clip-5">
            <div class="menu-content-item-top flex-row-align-center flex-row-justify-space-between cursor">
              <p class="font-size-16 font-bold">权限范围</p>
              <img src="@/assets/icon-lib-foldup.png" :class="!menuDisplay.permissionRanges.show?'transform':''" data-typ="permissionRanges" @click="closeMenu">
            </div>
  
            <div v-if="menuDisplay.permissionRanges.show">
              <div>
                <div class="menu-content-item-line" />
                <div class="menu-content-item-list">
                  <div v-for="cate in menu.scopeOfAuthority" :key="cate.name" class="menu-content-item-list-item" @click="selectRange(cate)">
                    <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="menuDisplay.permissionRanges.current == cate.code?'sel':''">
                      <p class="font-size-14">{{ cate.name }}</p>
                      <p v-if="cate.counrNumber>0" class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      menu: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        menuAllShow: false,
        currentCate: null,
        currentSubject: null,
        currentGenre: null,
        menuDisplay: {
          attributionType: {
            show: false,
            current: null
          }, subject: {
            show: false,
            current: null
          }, resourceType: {
            show: false,
            current: null
          }, tibetanTube: {
            show: false,
            current: null
          }, genre: {
            show: false,
            current: null
          }, region: {
            show: false,
            current: null
          }, personAffected: {
            show: false,
            current: null
          }, date: {
            show: false,
            current: null
          }, level: {
            show: false,
            current: null
          }, commitBy: {
            show: false,
            current: null
          }, publishTimes: {
            show: false,
            rangeDate: '',
            current: null
          }, copyrightOwner: {
            show: false,
            current: null
          }, permissionRanges: {
            show: false,
            current: null
          }, langue: {
            show: false,
            current: null
          }, subtitlesLangue: {
            show: false,
            current: null
          }, videoAndAudioLangue: {
            show: false,
            current: null
          }, resourceTimes: {
            show: false,
            current: null
          }, resourceCreateTimes: {
            show: false,
            current: null,
            rangeDate: ''
          }, widthHeight: {
            show: false,
            current: null
          }
  
        }
      }
    },
    watch: {
      menu() {
        this.prepearData()
      }
    },
    created() {
      this.prepearData()
    },
    methods: {
      prepearData() {
        if (this.menu) {
          this.menuAllShow = false
          const cates = this.menu.classificationResource
          const subject = this.menu.disciplineRsource
          const genre = this.menu.resourceGenre
  
          if (!this.currentCate) {
            this.menuAllShow = false
            this.changeAllMenu()
          }
          if (!this.currentCate || (this.currentCate && !this.currentCate.parent)) {
            this.currentCate = { parent: null, logs: cates }
          }
          if (!this.currentSubject || (this.currentSubject && !this.currentSubject.parent)) {
            this.currentSubject = { parent: null, logs: subject }
          }
          if (!this.currentGenre | (this.currentGenre && !this.currentGenre.parent)) {
            this.currentGenre = { parent: null, logs: genre }
          }
          this.prepeared = true
        }
      },
      prepearSubject(children) {
        const that = this
        children.forEach(v => {
          if (v.children) {
            that.prepearSubject(v.children)
          }
        })
      },
      prepearRegion(children) {
        const that = this
        children.forEach(v => {
          if (v.children) {
            that.prepearRegion(v.children)
          }
        })
      },
      changeAllMenu() {
        this.menuAllShow = !this.menuAllShow
        for (const key in this.menuDisplay) {
          const value = this.menuDisplay[key]
          value.show = this.menuAllShow
        }
      },
      closeMenu(v) {
        const type = v.currentTarget.dataset.typ
        this.menuDisplay[type].show = !this.menuDisplay[type].show
      },
      showMore(v) {
        this.$emit('showMore', { type: v.currentTarget.dataset.typ })
      },
      pudateChange() {
  
      },
      // 多级点击事件---------------------------
      // 分类点击事件
      selectCate(v) {
        if (this.menuDisplay.attributionType.current === v.cateName) {
          return
        }
        this.menuDisplay.attributionType.current = v.id
        if (v.children && v.children.length) {
          this.currentCate = { parent: v, logs: v.children }
        } else {
          // this.$emit('params', { params: { attributionType: v.id }, display: v.cateName, type: 'attributionType' })
        }
  
        this.$emit('params', { params: { attributionType: v.id }, display: v.cateName, type: 'attributionType' })
      },
      selectLastCate() {
        if (this.currentCate.parent.parentId === 0) {
          this.currentCate = { parent: null, logs: this.menu.classificationResource }
          this.menuDisplay.attributionType.current = null
          this.$emit('remove', { type: 'attributionType' })
        } else {
          const parentId = this.currentCate.parent.parentId
          this.findCatesById(parentId, this.menu.classificationResource)
        }
      },
      findCatesById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentCate = { parent: cate, logs: cate.children }
            this.$emit('params', { params: { attributionType: cate.id }, display: cate.cateName, type: 'attributionType' })
            return
          } else {
            if (cate.children.length) {
              this.findCatesById(cid, cate.children)
            }
          }
        }
      },
  
      // 学科点击事件
      selectSubject(v) {
        if (this.menuDisplay.subject.current === v.id) {
          return
        }
        this.menuDisplay.subject.current = v.id
        if (v.children && v.children.length) {
          this.currentSubject = { parent: v, logs: v.children }
        } else {
          // this.$emit('params', { params: { subject: v.id }, display: v.subjectName, type: 'subject' })
        }
        this.$emit('params', { params: { subject: v.id }, display: v.subjectName, type: 'subject' })
      },
      selectLastSubject() {
        if (this.currentSubject.parent.parentId === 0) {
          this.currentSubject = { parent: null, logs: this.menu.disciplineRsource }
          this.$emit('remove', { type: 'subject' })
        } else {
          const parentId = this.currentSubject.parent.parentId
          this.findSubjectsById(parentId, this.menu.disciplineRsource)
        }
      },
      findSubjectsById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentSubject = { parent: cate, logs: cate.children }
            this.$emit('params', { params: { subject: cate.id }, display: cate.subjectName, type: 'subject' })
            return
          } else {
            if (cate.children) {
              this.findSubjectsById(cid, cate.children)
            }
          }
        }
      },
  
      // 体裁事件
      selectGenre(v) {
        if (this.menuDisplay.genre.current === v.id) {
          return
        }
        this.menuDisplay.genre.current = v.id
        if (v.children) {
          this.currentGenre = { parent: v, logs: v.children }
        } else {
          // this.$emit('params', { params: { genre: v.genreName }, display: v.genreName, type: 'genre' })
        }
        this.$emit('params', { params: { genre: v.id }, display: v.genreName, type: 'genre' })
      },
      selectLastGenre() {
        if (this.currentGenre.parent.parentId === 0) {
          this.currentGenre = { parent: null, logs: this.menu.resourceGenre }
          this.$emit('remove', { type: 'genre' })
        } else {
          const parentId = this.currentGenre.parent.parentId
          this.findGenreById(parentId, this.menu.resourceGenre)
        }
      },
  
      findGenreById(cid, cates) {
        for (let i = 0; i < cates.length; i++) {
          const cate = cates[i]
          if (cate.id === cid) {
            this.currentGenre = { parent: cate, logs: cate.children }
            this.$emit('params', { params: { genre: cate.genreName }, display: cate.genreName, type: 'genre' })
            return
          } else {
            if (cate.children) {
              this.findGenreById(cid, cate.children)
            }
          }
        }
      },
      // menu 点击事件
      selectRange(r) {
        this.menuDisplay.permissionRanges.current = r.code
        this.$emit('params', { params: { permissionRanges: r.code }, display: r.name, type: 'permissionRanges' })
      },
      selectCopyRight(r) {
        this.menuDisplay.copyrightOwner.current = r.dictValue
        this.$emit('params', { params: { copyrightOwner: r.dictValue }, display: r.dictKey, type: 'copyrightOwner' })
      },
      selectPubDate(r) {
         
        if (r.name) {
          this.menuDisplay.publishTimes.current = r.name
          this.$emit('params', { params: { publishTimes: r.name }, display: r.name, type: 'publishTimes' })
        } else {
          if (this.menuDisplay.publishTimes.rangeDate.length) {
            const range = this.menuDisplay.publishTimes.rangeDate
            console.log(range)
            this.$emit('params', { params: { resourceTimesStarts: range[0] || '', resourceTimesend: range[1] || '' }, display: (range[0] || '') + '-' + (range[1] || ''), type: 'publishTimes' })
          }
        }
      },
      selectLanguage(r) {
        this.menuDisplay.langue.current = r.dictKey
        this.$emit('params', { params: { langue: r.dictKey }, display: r.dictValue, type: 'langue' })
      },
      selectShowLanguage(r) {
        this.menuDisplay.subtitlesLangue.current = r.dictKey
        this.$emit('params', { params: { subtitlesLangue: r.dictKey }, display: r.dictValue, type: 'subtitlesLangue' })
      },
      selectAudioLanguage(r) {
        this.menuDisplay.videoAndAudioLangue.current = r.dictKey
        this.$emit('params', { params: { videoAndAudioLangue: r.dictKey }, display: r.dictValue, type: 'videoAndAudioLangue' })
      },
      selectPubMan(r) {
        this.menuDisplay.commitBy.current = r.userId
        this.$emit('params', { params: { commitBy: r.userId }, display: r.userName, type: 'commitBy' })
      },
      selectCreateDate(r) {
        if (r.name) {
          this.menuDisplay.resourceCreateTimes.current = r.name
          this.$emit('params', { params: { resourceCreateTimes: r.name }, display: r.name, type: 'resourceCreateTimes' })
        } else {
          if (this.menuDisplay.resourceCreateTimes.rangeDate.length) {
            const range = this.menuDisplay.resourceCreateTimes.rangeDate
            this.$emit('params', { params: { resourceCreateTimesStarts: range[0] || '', resourceCreateTimesEnd: range[1] || '' }, display: (range[0] || '') + '-' + (range[1] || ''), type: 'resourceCreateTimes' })
          }
        }
      },
      selectDuration(r) {
        this.menuDisplay.resourceTimes.current = r.code
        this.$emit('params', { params: { resourceTimes: r.code }, display: r.name, type: 'resourceTimes' })
      },
      selectPerson(r) {
        this.menuDisplay.personAffected.current = r.name
        this.$emit('params', { params: { personAffected: r.name }, display: r.name, type: 'personAffected' })
      },
      selectTopic(r) {
        this.menuDisplay.tibetanTube.current = r.code
        this.$emit('params', { params: { tibetanTube: r.code }, display: r.name, type: 'tibetanTube' })
      },
      selectFileType(r) {
        this.menuDisplay.resourceType.current = r.code
        this.$emit('params', { params: { resourceType: r.code }, display: r.name, type: 'resourceType' })
      },
      selectWidth(r) {
        this.menuDisplay.widthHeight.current = r.name
        this.$emit('params', { params: { widthHeight: r.name }, display: r.name, type: 'widthHeight' })
      },
      clearAllFilter() {
        for (const key in this.menuDisplay) {
          const value = this.menuDisplay[key]
          value.current = null
        }
      },
      removeFilter(v) {
        this.menuDisplay[v].current = null
        if (this.menuDisplay[v].range) {
          this.menuDisplay[v].range = ''
        }
        if (v === 'attributionType') {
          this.currentCate = { parent: null, logs: this.menu.classificationResource }
        }
        if (v === 'subject') {
          this.currentSubject = { parent: null, logs: this.menu.disciplineRsource }
        }
        if (v === 'genre') {
          this.currentGenre = { parent: null, logs: this.menu.resourceGenre }
        }
      },
      resetFileSelectStatus(v) {
        for (const key in v) {
          const value = v[key]
          console.log(key)
          if (Object.hasOwnProperty.call(this.menuDisplay, key)) {
            this.menuDisplay[key].current = value
            console.log(value)
          }
        }
      }
    }
  }
  </script>
  <style src="@/styles/pc.css" scoped>
  </style>
  <style lang="scss" scoped>
    ::v-deep .el-select-dropdown__item{
      color: red($color: #000000) !important;
    }
    ::v-deep .el-input__icon{
      display: none;
    }
  
    ::v-deep .el-range-separator {
      width: 12% !important;
      line-height: 28px !important;
      color: #999 !important;
    }
  
    ::v-deep .el-range__close-icon {
      width: 0px !important;
    }
  
    ::v-deep .el-range-input {
      width: 44% !important;
    }
  
  </style>
  <style scoped>
    .page {
       width: 280px;
    }
    .menu {
      width: 280px;
    }
  
    .page  .menu .menu-header {
      height: 40px;
      width: 100%;
    }
  
    .page .menu .menu-content {
      margin-top: 20px;
    }
  
    .page  .menu .menu-content .menu-content-item {
      background-color: #F3F4F9;
      margin-bottom: 10px;
      /* padding-bottom: 10px; */
    }
  
    .page .menu .menu-content .menu-content-item .menu-content-item-top {
      height: 60px;
      padding: 0 20px;
    }
  
    .page  .menu .menu-content .menu-content-item-line {
      width: 100%;
      height: 1px;
      background-color: #264480;
      opacity: 0.1;
    }
  
    .page  .menu .menu-content .menu-content-item-list {
      padding: 10px;
    }
  
    .menu-content-item-list-item-hg {
      height: 30px;
      padding: 0 10px;
    }
  
    .page  .menu .menu-content .menu-content-item-list-item-sel {
      background-color:  rgba(38, 42, 51, 0.4);
    }
  
    .page .menu .menu-content .menu-content-item-list-item-sel .menu-content-item-list-item-sel-text{
      color: #fff;
    }
  
    .menu-content-item-list-item-child {
      height: 30px;
      padding: 0 10px;
    }
  
    .menu-content-item-list-item-children {
      padding-left: 5px;
    }
  
    .menu-content-item-list-item-rang {
      width: 170px;
      height: 30px;
      border: 1px solid rgba(26, 59, 128, 0.2);
    }
  
    .menu-content-item-list-item-rang .start {
      left: 0;
      width: 60px;
      z-index: 99;
      opacity: 0;
    }
  
    .menu-content-item-list-item-rang .end {
      left: 0;
      width: 60px;
      z-index: 99;
      opacity: 0;
    }
  
    .menu-content-item-list-item-rang>div {
      padding: 0 10px;
    }
  
    .menu-content-item-list-item-button {
      width: 60px;
      height: 30px;
      margin-left: 10px;
    }
  
    .menu-content-item-more {
      height: 30px;
      padding-right: 10px;
      margin-bottom: 10px;
    }
  
    .transform {
      transform: rotate(180deg);
    }
  
    .character {
     margin-right: 6px;
     display: flex;
     align-items: flex-start;
     justify-content: flex-end;
    }
  
    .sel {
     background-color: rgba(147, 150, 156, 0.4);
    }
  
    .sel p {
      color: #fff;
    }
  
  </style>
  